import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'passFail',
})
export class PassFailPipe implements PipeTransform {

  transform(value: any): any {
    if (value) {
      switch (value) {
        case 'Yes':
          return 'Pass';
        case 'No':
          return 'Fail';
        default:
          return 'N/A';
      }
    } else {
      return 'N/A';
    }
  }
}
